import React, { Fragment, useEffect, useState, Component, useCallback, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Progress, Label, Input, Spinner, Table, Col, Container, Row, Card, CardBody, CardHeader, Modal, ModalHeader, NavLink, Nav, NavItem, ModalBody, TabContent, TabPane, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Button } from "reactstrap";
import { api } from "../../../config";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import logo from "../../../assets/images/logo-sm.png";
import parse from "html-react-parser";
import classnames from "classnames";
import ModalImage from "react-modal-image";
import ReactApexChart from "react-apexcharts";
import { useReactToPrint } from "react-to-print";
import SimpleBar from "simplebar-react";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";

import moment from "moment";
import { getCivilBudget, resetCivilBudgetState } from "../../../store/civilBudget/action";
import { getCivilOpname, resetCivilOpnameState } from "../../../store/civilOpname/action";
import { resetVendorState, getVendor } from "../../../store/vendor/action";
import { resetCivilContractState, getCivilContract as onGetCivilContracts } from "../../../store/civilContract/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { getDashboard, resetDashboardState } from "../../../store/dashboard/action";
import { find, isEmpty } from "lodash";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import ExportDoc from "../../../Components/Common/ExportDoc";
import PrintDocx from "../PrintDocx";
import Siteplan from "../Siteplan";

const ProgressDashboard = () => {
  document.title = "Dashboard";
  const printSiteRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);
  const [loadingPrintSite, setLoadingPrintSite] = useState(false);
  const dispatch = useDispatch();
  const date = new Date().getHours();

  //
  const [modal, setModal] = useState(false);
  const [modalMaterial, setModalMaterial] = useState(false);
  const [label, setLabel] = useState([]);
  const [dashboard, setDashboard] = useState({});
  const [isBuildingOpname, setIsBuildingOpname] = useState(true);
  const [info, setInfo] = useState([]);
  const [svg, setSVG] = useState("");
  const [svgProject, setSVGProject] = useState("");
  const [civilBudgetList, setCivilBudgetList] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [productList, setProductList] = useState([]);
  const [vendorJobList, setVendorJobList] = useState([]);
  const opnameListRef = useRef([]);
  const [civilContractSummaryList, setCivilContractSummaryList] = useState([]);
  const [civilContractSummaryJobList, setCivilContractSummaryJobList] = useState([]);
  const [civilContractSummaryJobSupplierList, setCivilContractSummaryJobSupplierList] = useState([]);
  const [expense, setExpense] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [vendorCount, setVendorCount] = useState(0);
  const [pekerjaanList, setPekerjaanList] = useState([]);
  const [selectedMandor, setSelectedMandor] = useState(null);
  const [selectedPekerjaan, setSelectedPekerjaan] = useState(null);
  const [bobotMap, setBobotMap] = useState({});
  const [mandorOpnames, setMandorOpnames] = useState([]);
  const pendingBlocksRef = useRef(null);
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [unit, setUnit] = useState(0);
  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const expanseDataRef = useRef([]);
  const [filterBy, setFilterBy] = useState("");
  const [chartProjectCategory, setChartProjectCategory] = useState([]);
  const [chartProjectColor, setChartProjectColor] = useState([]);
  const [chartProjectData, setChartProjectData] = useState([
    {
      name: "RAB",
      type: "line",
      data: [],
    },
    {
      name: "RAP",
      type: "line",
      data: [],
    },
  ]);


  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, dashboards, loading, error, productVarians, productVarianLoading, civilBudgets, civilBudgetLoading, vendors, vendorLoading, civilContracts, civilContractLoading, civilOpnames, civilOpnameLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    dashboards: state.Dashboard.dashboards,
    loading: state.Dashboard.loading,
    catalogAvailable: state.Catalog.catalogAvailable,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    vendors: state.Vendor.vendors,
    vendorLoading: state.Vendor.loading,
    civilContracts: state.CivilContract.civilContracts,
    civilContractLoading: state.CivilContract.loading,
    civilOpnames: state.CivilOpname.civilOpnames,
    civilOpnameLoading: state.CivilOpname.loading,
  }));

  const reactToPrintContent = useCallback(() => {
    return printSiteRef.current;
  }, [printSiteRef]);

  const handleAfterPrint = useCallback(() => { }, []);

  const handleBeforePrint = useCallback(() => { }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrintSite(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrintSite(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrintSite]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <i className="ri-image-line me-1  align-bottom text-info "></i>;
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected && clientSelected) {
      setPositionMessage(`${userData?.user?.user_department?.name}, ${userData?.user?.user_position?.name}`);
      handleGetDefault(clientSelected.value, companySelected.value, branchSelected.value, branchSelected.svg_siteplan, branchSelected.svg_rincik, branchSelected.svg_siteplan_project);
    }
  }, [branchSelected, companySelected, clientSelected]);

  useEffect(() => {
    if (!isEmpty(dashboards)) {
      setDashboard(dashboards);
    } else {
      setDashboard({});
    }
  }, [dashboards]);

  const handleGetProductVariant = (companyId, branchId, type) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, branchId: branchId, type: type, status: 2 }));
  };

  const handleCivilBudget = (id, branchId, type) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: id, branchId: branchId }));
  };

  const handleCivilOpname = (id, branchId, product) => {
    dispatch(resetCivilOpnameState());
    dispatch(getCivilOpname({ companyId: id, branchId: branchId, productId: product }));
  };

  const [justifyPillsTab, setjustifyPillsTab] = useState("3");
  const justifyPillsToggle = (tab) => {
    if (justifyPillsTab !== tab) {
      setjustifyPillsTab(tab);
    }
  };

  const handleGetDefault = (clientId, companyId, branchId, svg, svg_rincik, svg_siteplan_project) => {
    dispatch(resetDashboardState());
    dispatch(getDashboard({ branchId: branchId, companyId: companyId, clientId: clientId }));
    handleCivilBudget(companyId, branchId, "PROGRESS BANGUNAN");
    handleGetProductVariant(companyId, branchId, 1);
    dispatch(resetVendorState());
    dispatch(getVendor());
    dispatch(resetCivilContractState());
    dispatch(onGetCivilContracts({ companyId: companyId, branchId: branchId }));
    setSVG(svg);
    setSVGProject(svg_siteplan_project);
    // setSVGRincik(svg_rincik);
    handleCivilOpnames(companyId, branchId);
  };

  const handleCivilOpnames = (id, branchId) => {
    dispatch(resetCivilOpnameState());
    dispatch(getCivilOpname({ companyId: id, branchId: branchId }));
  };

  const toggle = useCallback(() => {
    if (modal) {
      handleCivilOpnames(companySelected.value, branchSelected.value);
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  useEffect(() => {
    setProductList(productVarians);
  }, [productVarians]);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      const vendorIds = new Set((civilContracts || []).filter(f => f.statusId === 1 || f.statusId === 2).map((c) => c.vendorId));
      var vendorData = [];
      var opt = [];
      vendors.filter((item) => vendorIds.has(item.id)).forEach((item) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      vendorData.push(option);
      setVendorList(vendorData);
      setVendorCount(opt.length);
    } else {
      setVendorList([]);
      setVendorCount(0);
    }
  }, [vendors, civilContracts]);


  useEffect(() => {
    let arr = [];
    let arrJob = [];
    let arrJobSupplier = [];
    let filtered = civilContracts.filter((f) => (f.statusId === 1 || f.statusId === 2) && f.vendorId === selectedMandor?.value);

    for (const data of filtered) {
      if (!arr.length) {
        arr.push({ vendor: data?.cvl_contract_vendor?.name, vendorId: data.vendorId, data: [data] })
      }
      else {
        const findData = arr.find(f => f.vendorId === data.vendorId);
        if (findData) {
          findData.data.push(data);
        }
        else {
          arr.push({ vendor: data?.cvl_contract_vendor?.name, vendorId: data.vendorId, data: [data] })
        }
      }

      for (const bdg of data.budget) {
        if (!arrJob.length) {
          arrJob.push({ name: bdg.label, amount: bdg.amount, vendor: [data?.cvl_contract_vendor?.name], unit: data.unit.length });
        }
        else {
          const findData = arrJob.find(f => f.name === bdg.label);
          if (findData) {
            findData.unit += data.unit.length;
            const findVendor = (findData.vendor || []).find(f => f === data?.cvl_contract_vendor?.name);
            if (!findVendor) findData.vendor.push(data?.cvl_contract_vendor?.name);
          }
          else {
            arrJob.push({ name: bdg.label, amount: bdg.amount, vendor: [data?.cvl_contract_vendor?.name], unit: data.unit.length });
          }
        }
      }

      for (const bdg of data.budget) {
        if (!arrJobSupplier.length) {
          arrJobSupplier.push({ name: bdg.label, amount: bdg.amount, vendor: data?.cvl_contract_vendor?.name, unit: data.unit.length });
        }
        else {
          const findData = arrJobSupplier.find(f => f.name === bdg.label && f.vendor === data?.cvl_contract_vendor?.name);
          if (findData) {
            findData.unit += data.unit.length;
          }
          else {
            arrJobSupplier.push({ name: bdg.label, amount: bdg.amount, vendor: data?.cvl_contract_vendor?.name, unit: data.unit.length });
          }
        }
      }
    }
    setCivilContractSummaryList(arr);
    setCivilContractSummaryJobList(arrJob);
    setCivilContractSummaryJobSupplierList(arrJobSupplier);
  }, [civilContracts, selectedMandor]);

  useEffect(() => {
    let list = [];
    let data = [];
    let opt = [];
    civilBudgets.forEach((it, idx) => {
      const name = it.cvl_branch ? it.cvl_branch.name + " - " + it.name : it.name;
      const id = it.id;
      let obj = { label: name, value: id, data: it };
      opt.push(obj);
      (it.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order) || []).forEach((item, key) => {
        let cat = item.cvld_account && item.cvld_account.cvl_account_category ? item.cvld_account.cvl_account_category.name : "";
        let findCategory = list.find((x) => x.category === cat);
        if (findCategory) {
          findCategory.data.push(item);
        } else {
          list.push({ type: it.type, category: cat, data: [item] });
        }
      });
    });
    setCivilBudgetList(list);

  }, [civilBudgets]);


  useEffect(() => {
    if (selectedMandor) {
      let opt = [];
      var pekerjaan = [];
      let contracts = (civilContracts || []).filter((c) => c.vendorId === selectedMandor.value);
      contracts.forEach((data) => {
        const find = opt.find(f => f.value === data?.cvl_contract_cvl_account?.id)
        if (!find) opt.push({ label: data?.cvl_contract_cvl_account?.name, value: data?.cvl_contract_cvl_account?.id, budget: data?.budget });
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      pekerjaan.push(option);
      setPekerjaanList(pekerjaan);
    } else {
      setPekerjaanList([]);
    }
  }, [selectedMandor, civilContracts, civilBudgets]);

  useEffect(() => {
    if (selectedMandor) {
      let blocks = [];
      (civilContracts || []).filter((c) => c.vendorId === selectedMandor.value).forEach((data) => {
        (data.block || []).forEach((b) => {
          if (b && b.value != null && blocks.indexOf(b.value) === -1) blocks.push(b.value);
        });
      });
      if (blocks.length) {
        pendingBlocksRef.current = blocks;
        dispatch(resetCivilOpnameState());
        dispatch(getCivilOpname({ block: JSON.stringify(blocks) }));
      }
    } else {
      pendingBlocksRef.current = null;
      setMandorOpnames([]);
      dispatch(resetCivilOpnameState());
    }
  }, [selectedMandor, civilContracts]);

  useEffect(() => {
    if (selectedMandor && pendingBlocksRef.current && civilOpnames.length) {
      setMandorOpnames(civilOpnames);
      pendingBlocksRef.current = null;
    }
  }, [civilOpnames]);

  useEffect(() => {
    const map = {};
    if (selectedMandor && !isEmpty(civilBudgets) && mandorOpnames.length) {
      const contracts = (civilContracts || []).filter((c) => c.vendorId === selectedMandor.value);
      const accountAmount = {};
      civilBudgets.forEach((acc) => {
        if (acc.type === "UPAH") {
          (acc.cvl_detail || []).forEach((account) => {
            if (account && account?.cvld_account) {
              accountAmount[String(account?.cvld_account?.id)] = !isNaN(parseFloat(account.amount)) ? parseFloat(account.amount) : 0;
            }
          });
        }
      });
      const units = new Map();
      contracts.forEach((c) =>
        (c.unit || []).forEach((u) => {
          if (u && u.value != null && !units.has(u.value)) units.set(u.value, u);
        })
      );
      units.forEach((_, productId) => {
        const covering = contracts.filter((c) => (c.unit || []).some((u) => u.value === productId));
        const budgetIds = [];
        covering.forEach((c) =>
          (c.budget || []).forEach((b) => {
            if (b && b.civilAccountId != null && budgetIds.indexOf(b.civilAccountId) === -1) budgetIds.push(b.civilAccountId);
          })
        );
        let amount_total = 0;
        let amount = 0;
        budgetIds.forEach((id) => {
          amount_total += accountAmount[String(id)] || 0;
        });
        mandorOpnames.filter((f) => f?.cvlop_product?.id === productId).forEach((detail) => {
          let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
          budgetIds.forEach((id) => {
            if (m.indexOf(String(id)) !== -1) amount += accountAmount[String(id)] || 0;
          });
        });
        map[productId] = amount_total ? parseFloat((amount / amount_total) * 100).toFixed(2) : 0;
      });
    }
    setBobotMap(map);
  }, [selectedMandor, civilContracts, civilBudgets, mandorOpnames]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    const containerSvgEl = document.getElementById("_0");

      if (containerSvgEl) {
        containerSvgEl.childNodes.forEach((el) => {
          if (el.nodeType === 1) {
            el.style.fill = "";
          }
        });
      }

      for (const varian of productList) {
        let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
        let name = varian.pvar_product.name;
        let ele = document.getElementById(block + "-" + name);
        if (ele) {
          ele.removeAttribute("class");
          ele.style.fill = "#FFFFFF";
        }
      }

      let blokMandor = [];
      for (const contract of civilContracts.filter(f => f.vendorId === selectedMandor?.value && f.civilAccountId === selectedPekerjaan?.value && (f.statusId === 1 || f.statusId === 2))) {
        for (const unit of (contract.unit || [])) {
          blokMandor.push(unit.productId)
        }
      }

      let arrUnit = [];
      for (const varian of productList) {
        let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
        let name = varian.pvar_product.name;
        let productId = varian.pvar_product.id;
        let category = varian.pvar_product.product_category ? varian.pvar_product.product_category.name : "";
        varian.key = block + "-" + name;
        varian.name = category + ", " + block + "-" + name;
        varian.image = varian.pvar_product.image;
        varian.isMatch = false;

        if (blokMandor.includes(productId)) {
          let weight = 0;
          let amount = 0;
          let amount_total = 0;
          let completed = 0;
          let jobList = [];
          const findOpname = civilOpnames.filter((f) => f?.cvlop_product?.id === productId);
          for (const detail of findOpname || []) {
            let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
            for (const acc of civilBudgets) {
              for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
                if (account.type === "UPAH") {
                  let findAccount = m.indexOf((account?.cvld_account?.id ?? "").toString());
                  if (selectedPekerjaan.budget.length > 0) {
                    const findBudget = selectedPekerjaan.budget.find((x) => x.civilAccountId === account?.cvld_account?.id);
                    let job;
                    if (findAccount !== -1 && findBudget) {
                      weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
                      amount += !isNaN(parseFloat(account.amount)) ? parseFloat(account.amount) : 0;
                      completed += 1;
                      job = { name: account?.cvld_account?.name, weight: account.weight, isFinished: true };
                    }

                    if (findBudget && findAccount < 0) {
                      job = { name: account?.cvld_account?.name, weight: account.weight, isFinished: false };
                    }
                    if (job) jobList.push(job);

                    if (findBudget) amount_total += !isNaN(parseFloat(account.amount)) ? parseFloat(account.amount) : 0;
                  }
                }
              }
            }
          }
          let percentage = !isNaN(parseFloat((amount / amount_total) * 100)) ? parseFloat((amount / amount_total) * 100).toFixed(2) : 0;
          let ele = document.getElementById(block + "-" + name);
          varian.isMatch = true;
          let w = parseFloat(percentage);
          varian.weight = w
          varian.jobs = jobList;
          if (ele) {
            let color = "#cccccc";

            if (w >= 90) color = "#76C457";
            if (w >= 0 && w < 30) color = "#E45742";
            if (w >= 30 && w < 60) color = "#F4EB6C";
            if (w >= 60 && w < 90) color = "#B0CDE6";
            ele.removeAttribute("class");
            ele.style.fill = color;
            varian.color = color;
          }
        }
        arrUnit.push(varian);
      }

      setVendorJobList(arrUnit.filter(f => f.isMatch));
      opnameListRef.current = arrUnit;
  }, [svg, dashboards, civilBudgets, civilBudgetLoading, productList, productVarianLoading, justifyPillsTab, selectedPekerjaan, bobotMap]);

  useEffect(() => {
    const handleDocumentClick = (element) => {
      if (element.target.id) {
        let data = opnameListRef.current.find((x) => x.key === element.target.id);
        console.log(data);
        if (data && data.isMatch) {
          handleCivilOpname(companySelected?.value, branchSelected?.value, data.productId);
          setInfo(data);
          toggle();
        }
      }
    };
    const handleDocumentMouseover = (element) => {
      if (element.target.id) {
        let data = opnameListRef.current.find((x) => x.key === element.target.id);
        if (data && data.isMatch) {
          setInfo(data);
          let svgEl = document.getElementById(data.key);
          let mypopup = document.getElementById("dashboard-custom-tooltip");
          if (!svgEl || !mypopup) return;
          let iconPos = svgEl.getBoundingClientRect();
          mypopup.style.left = iconPos.right < 1000 ? iconPos.right + 10 + "px" : iconPos.right - 460 + 10 + "px";
          mypopup.style.top = window.scrollY + iconPos.top - 60 + "px";
          mypopup.style.display = "block";
        }
      }
    };
    const handleDocumentMouseout = (element) => {
      if (element.target.id) {
        let data = opnameListRef.current.find((x) => x.key === element.target.id);
        if (data) {
          let mypopup = document.getElementById("dashboard-custom-tooltip");
          if (mypopup) mypopup.style.display = "none";
        }
      }
    };
    document.body.addEventListener("click", handleDocumentClick);
    document.body.addEventListener("mouseover", handleDocumentMouseover);
    document.body.addEventListener("mouseout", handleDocumentMouseout);
    return () => {
      document.body.removeEventListener("click", handleDocumentClick);
      document.body.removeEventListener("mouseover", handleDocumentMouseover);
      document.body.removeEventListener("mouseout", handleDocumentMouseout);
    };
  }, [isBuildingOpname]);

  const toggleMaterial = useCallback(() => {
    if (modalMaterial) {
      setModalMaterial(false);
    } else {
      setModalMaterial(true);
    }
  }, [modalMaterial]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "name",
        label: "Material",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "amount" || doc.id === "quantity" || doc.id === "amount_total") {
                doc.data.push(currencyFormat(parseFloat(value || 0) || 0));
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [expense]);

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return el.amount.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.description.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.transaction_no.toLowerCase().indexOf(query.toLowerCase()) !== -1 || el.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  const ParsedSVG = useMemo(() => {
    let content = svgProject && parse(svgProject);

    return <div>{content}</div>;
  }, [svgProject, isBuildingOpname]);

  useEffect(() => {
    if (vendorJobList)
      console.log(vendorJobList);
    ///
  }, [vendorJobList]);


  const civilContractAmounts = (civilContracts || []).filter(f => f.statusId === 1 || f.statusId === 2).map((v) => ({
    amount: parseFloat(v.amount || 0),
    payable: parseFloat(v.payable_amount || 0),
    paid: parseFloat(v.paid_amount || 0),
  }));
  const totalNilaiSpk = civilContractAmounts.reduce((a, v) => a + v.amount, 0);
  const totalMenungguOpname = civilContractAmounts.reduce((a, v) => a + (v.amount - v.payable), 0);
  const totalTerbayar = civilContractAmounts.reduce((a, v) => a + v.paid, 0);
  const totalMenungguBayar = civilContractAmounts.reduce((a, v) => a + (v.amount - v.paid), 0);
  const pct = (num, denom) => (denom ? (num / denom) * 100 : 0);
  const pctMenungguOpname = pct(totalMenungguOpname, totalNilaiSpk);
  const pctTerbayar = pct(totalTerbayar, totalNilaiSpk);
  const pctMenungguBayar = pct(totalMenungguBayar, totalNilaiSpk);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Row className="mb-3 pb-1">
                  <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                      <div className="flex-grow-1">
                        <h4 className="fs-16 mb-1">
                          {date < 12 ? "Selamat Pagi" : date >= 12 && date <= 15 ? "Selamat Siang" : date < 18 ? "Selamat Sore" : "Selamat Malam"} {userData?.name}{" "}
                          {(loading || civilBudgetLoading || civilOpnameLoading) && (
                            <>
                              <Spinner color="primary" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                              &nbsp;
                              <Spinner color="success" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                            </>
                          )}
                        </h4>
                        <p>{userType !== "agent" ? positionMessage : ""}</p>
                      </div>
                      <div className="mt-3 mt-lg-0">
                        <form action="#">
                          <Row className="g-3 mb-0 align-items-center">
                            <div className="col-sm-auto">
                              <div className="input-group">
                                <Flatpickr
                                  className="form-control border-0 dash-filter-picker shadow"
                                  options={{
                                    mode: "range",
                                    dateFormat: "Y/m/d",
                                  }}
                                  onChange={(selectedDates, dateStr) => {
                                    let startat = "";
                                    let endat = "";
                                    let datearr = dateStr.split(" to ");
                                    if (datearr[1]) {
                                      startat = datearr[0];
                                      endat = datearr[1] ? datearr[1] : datearr[0];
                                    }
                                    //dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, startat: startat, endat: endat }));
                                  }}
                                />
                                <div className="input-group-text bg-primary border-primary text-white">
                                  <i className="ri-calendar-2-line"></i>
                                </div>
                                <UncontrolledDropdown className="card-header-dropdown ms-2 mt-2" direction="start">
                                  <DropdownToggle tag="a" className="text-reset" role="button">
                                    <span className="fw-semibold text-uppercase fs-12">Filter by: </span>
                                    <span className="text-muted">
                                      {filterBy} <i className="mdi mdi-chevron-down ms-1"></i>
                                    </span>
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Hari Ini");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "today" }));
                                      }}
                                    >
                                      Hari Ini
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Kemarin");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "yesterday" }));
                                      }}
                                    >
                                      Kemarin
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("7 Hari Terakhir");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "last7day" }));
                                      }}
                                    >
                                      7 Hari Terakhir
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("30 Hari Terakhir");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "last30day" }));
                                      }}
                                    >
                                      30 Hari Terakhir
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Bulan Ini");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "thismonth" }));
                                      }}
                                    >
                                      Bulan Ini
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setFilterBy("Bulan Lalu");
                                        dispatch(resetDashboardState());
                                        dispatch(getDashboard({ branchId: branchSelected.value, companyId: companySelected.value, clientId: clientSelected.value, filter: "lastmonth" }));
                                      }}
                                    >
                                      Bulan Lalu
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </div>
                            </div>
                          </Row>
                        </form>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="row-cols-md-2 row-cols-xl-5 g-3">
                  <Col>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <p className="text-uppercase fw-medium text-muted mb-0">
                              TOTAL VENDOR
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp
                                start={0}
                                separator="."
                                decimal=","
                                prefix=""
                                decimals=""
                                end={vendorCount}
                                duration={1}
                                className="counter-value"
                              />
                            </h4>
                            <span className="badge bg-info me-2">{vendorCount}</span>
                            <span className="text-muted">Mandor</span>
                          </div>
                          <div className="avatar-xs flex-shrink-0">
                            <span className="avatar-title bg-light rounded fs-3">
                              <FeatherIcon
                                icon="users"
                                className="text-primary icon-dual-success"
                              />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1"><p className="text-uppercase fw-medium text-muted mb-0">TOTAL NILAI SPK</p></div>
                          <div className="flex-shrink-0"></div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp start={0} separator="." decimal="," prefix="" decimals="" end={totalNilaiSpk} duration={1} className="counter-value" />
                            </h4>
                            <span className="badge bg-info me-2">{(civilContracts || []).filter(f => f.statusId === 1 || f.statusId === 2).length}</span>
                            <span className="text-muted">Transaksi</span>
                          </div>
                          <div className="avatar-xs flex-shrink-0"><span className="avatar-title bg-light rounded fs-3"><FeatherIcon icon="book" className="text-success icon-dual-success" /></span></div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1"><p className="text-uppercase fw-medium text-muted mb-0">MENUNGGU OPNAME</p></div>
                          <div className="flex-shrink-0"><h5 className={pctMenungguOpname > 50 ? "fs-14 mb-0 text-success" : "fs-14 mb-0 text-warning"}> <i className={pctMenungguOpname > 50 ? "ri-arrow-right-up-line fs-13 me-2 align-middle" : "ri-arrow-right-down-line fs-13 me-2 align-middle"}></i> {pctMenungguOpname.toFixed(2)} %</h5></div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp start={0} separator="." decimal="," prefix="" decimals="" end={totalMenungguOpname} duration={1} className="counter-value" />
                            </h4>
                            <span className="badge bg-info me-2">{(civilContracts || []).filter(f => f.statusId === 1 || f.statusId === 2).filter(f => (parseFloat(f.amount || 0) - parseFloat(f.payable_amount || 0)) > 0).length}</span>
                            <span className="text-muted">Transaksi</span>
                          </div>
                          <div className="avatar-xs flex-shrink-0"><span className="avatar-title bg-light rounded fs-3"><FeatherIcon icon="file-text" className="text-success icon-dual-success" /></span></div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1"><p className="text-uppercase fw-medium text-muted mb-0">TERBAYAR</p></div>
                          <div className="flex-shrink-0"><h5 className={pctTerbayar > 50 ? "fs-14 mb-0 text-success" : "fs-14 mb-0 text-warning"}> <i className={pctTerbayar > 50 ? "ri-arrow-right-up-line fs-13 me-2 align-middle" : "ri-arrow-right-down-line fs-13 me-2 align-middle"}></i> {pctTerbayar.toFixed(2)} %</h5></div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp start={0} separator="." decimal="," prefix="" decimals="" end={totalTerbayar} duration={1} className="counter-value" />
                            </h4>
                            <span className="badge bg-info me-2">{(civilContracts || []).filter(f => f.statusId === 1 || f.statusId === 2).filter(f => parseFloat(f.paid_amount || 0) > 0).length}</span>
                            <span className="text-muted">Transaksi</span>
                          </div>
                          <div className="avatar-xs flex-shrink-0"><span className="avatar-title bg-light rounded fs-3"><FeatherIcon icon="check-square" className="text-success icon-dual-success" /></span></div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col>
                    <Card className="card-animate">
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1"><p className="text-uppercase fw-medium text-muted mb-0">MENUNGGU BAYAR</p></div>
                          <div className="flex-shrink-0"><h5 className={pctMenungguBayar > 50 ? "fs-14 mb-0 text-success" : "fs-14 mb-0 text-warning"}> <i className={pctMenungguBayar > 50 ? "ri-arrow-right-up-line fs-13 me-2 align-middle" : "ri-arrow-right-down-line fs-13 me-2 align-middle"}></i> {pctMenungguBayar.toFixed(2)} %</h5></div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-1">
                          <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                              <CountUp start={0} separator="." decimal="," prefix="" decimals="" end={totalMenungguBayar} duration={1} className="counter-value" />
                            </h4>
                            <span className="badge bg-info me-2">{(civilContracts || []).filter(f => f.statusId === 1 || f.statusId === 2).filter(f => (parseFloat(f.amount || 0) - parseFloat(f.paid_amount || 0)) > 0).length}</span>
                            <span className="text-muted">Transaksi</span>
                          </div>
                          <div className="avatar-xs flex-shrink-0"><span className="avatar-title bg-light rounded fs-3"><FeatherIcon icon="clock" className="text-success icon-dual-success" /></span></div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12}>
                    <Card className="card-height-100">
                      <CardHeader className="align-items-center d-flex gap-2 border-0 pb-0">
                        <h4 className="flex-grow-1 py-2 mb-sm-0 fw-semibold">OPNAME PEKERJAAN {(loading || civilBudgetLoading || civilContractLoading || productVarianLoading) && (
                          <>
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </>
                        )}</h4>
                        <div className="flex-shrink-0  d-flex gap-2" style={{ minWidth: "400px" }}>
                          <div style={{ minWidth: "200px" }}>
                            <Select
                              name="mandor"
                              value={selectedMandor}
                              placeholder="Pilih Mandor"
                              isClearable
                              isSearchable
                              onChange={(e) => {
                                setSelectedPekerjaan(null);
                                setSelectedMandor(e);
                              }}
                              options={vendorList}></Select>
                          </div>
                          <div style={{ minWidth: "200px" }}>
                            <Select
                              name="pekerjaan"
                              value={selectedPekerjaan}
                              placeholder="Pilih Pekerjaan"
                              isClearable
                              isSearchable
                              onChange={(e) => setSelectedPekerjaan(e)}
                              options={pekerjaanList}></Select>
                          </div>

                          {vendorLoading && (
                            <Spinner color="primary" size="sm" className="align-self-center flex-shrink-0">
                              Loading...
                            </Spinner>
                          )}

                          <div className=" justify-content-end">
                            <button type="submit" className="btn btn-success" onClick={handlePrint}>
                              PRINT SITEPLAN &nbsp;
                              {loadingPrintSite && <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner>}
                            </button>
                          </div>
                        </div>
                      </CardHeader>
                      <div style={{ position: "relative" }}>
                        <div ref={printSiteRef}>
                          <CardBody className="siteplan-svg">
                            <Siteplan salesLoading={civilOpnameLoading} justifyPillsTab={justifyPillsTab} component={ParsedSVG} />
                            {selectedMandor?.label && <div className="fs-16 mb-3 fw-semibold">{selectedMandor?.label} {selectedPekerjaan?.label ? " - " + selectedPekerjaan?.label : ""}</div>}
                            <div className="hstack gap-3">
                              <div className="card align-items-center p-2" style={{ width: 100 / 5 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #cccccc" }}>
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0 avatar-xs me-2">
                                    <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#cccccc" }}>
                                      {vendorJobList.filter((o) => o.isMatch).length}
                                    </div>
                                  </div>
                                  <div className="col-auto fs-11 text-center flex-grow-1"> TOTAL UNIT</div>
                                </div>
                              </div>

                              <div className="card align-items-center p-2" style={{ width: 100 / 4 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #E45742" }}>
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0 avatar-xs me-2">
                                    <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#E45742" }}>
                                      {vendorJobList.filter((o) => o.weight < 1).length}
                                    </div>
                                  </div>
                                  <div className="col-auto fs-11 text-center flex-grow-1">PROGRES &lt; 30%</div>
                                </div>
                              </div>
                              <div className="card align-items-center p-2" style={{ width: 100 / 5 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #F4EB6C" }}>
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0 avatar-xs me-2">
                                    <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#F4EB6C" }}>
                                      {vendorJobList.filter((o) => o.weight > 30 && o.weight <= 60).length}
                                    </div>
                                  </div>
                                  <div className="col-auto fs-11 text-center flex-grow-1">PROGRES 30-60%</div>
                                </div>
                              </div>
                              <div className="card align-items-center p-2" style={{ width: 100 / 5 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #B0CDE6" }}>
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0 avatar-xs me-2">
                                    <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#B0CDE6" }}>
                                      {vendorJobList.filter((o) => o.weight > 60 && o.weight <= 90).length}
                                    </div>
                                  </div>
                                  <div className="col-auto fs-11 text-center flex-grow-1">PROGRES 60-90%</div>
                                </div>
                              </div>
                              <div className="card align-items-center p-2" style={{ width: 100 / 5 + "%", minHeight: "34px", verticalAlign: "middle", border: "1px solid #76C457" }}>
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0 avatar-xs me-2">
                                    <div className="avatar-title fw-semibold rounded-circle fs-13 text-dark" style={{ background: "#76C457" }}>
                                      {vendorJobList.filter((o) => o.weight > 90).length}
                                    </div>
                                  </div>
                                  <div className="col-auto fs-11 text-center flex-grow-1">PROGRES &gt; 90%</div>
                                </div>
                              </div>
                            </div>
                            {vendorJobList.filter(f => !f.color).length > 0 && <div className="mb-3">
                              <p>Gagal mewarnai blok karena ID BLOK pada SVG Siteplan tidak ditemukan (hubungi Sistem Admin)  adapun progress blok tersebut adalah sebagai berikut :</p>
                              {vendorJobList.filter(f => !f.color).sort((a, b) => (a.key ?? "").localeCompare((b.key ?? ""), undefined, { numeric: true, sensitivity: "base" })).map((d, i) => {
                                let color = "#cccccc";
                                let w = d.weight;
                                if (w >= 90) color = "#76C457";
                                if (w >= 0 && w < 30) color = "#E45742";
                                if (w >= 30 && w < 60) color = "#F4EB6C";
                                if (w >= 60 && w < 90) color = "#B0CDE6";
                                return <span className="badge text-uppercase me-1 mb-1" style={{ backgroundColor: color }} key={d.key}>
                                  {d.key}
                                </span>
                              })}
                            </div>}

                          </CardBody>
                        </div>

                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={12}>
              <Card>
                <CardBody className="pt-0 mt-3">
                  {civilContractSummaryList.map((d, i) => {
                    return <div className="" key={i}>
                      <h3 className="card-title mb-3 text-info text-left fw-semibold">{d.vendor}</h3>
                      <table className="table mb-5 table-border fs-12">
                        <thead className="align-middle">
                          <tr className="table-active text-left fs-12 fw-semibold">
                            <td className="text-start" style={{ width: "2%" }}>No</td>
                            <td className="text-start" style={{ width: "8%" }}>Tanggal SPK</td>
                            <td className="" style={{ width: "8%" }}>No SPK</td>
                            <td className="" style={{ width: "28%" }}>Item Pekerjaan</td>
                            <td className="text-end" style={{ width: "10%" }}>Sub Total</td>
                            <td className="text-center" style={{ width: "4%" }}>Unit</td>
                            <td className="text-end" style={{ width: "10%" }}>Total</td>
                            <td className="text-end" style={{ width: "10%" }}>Tagihan</td>
                            <td className="text-end" style={{ width: "10%" }}>Terbayar</td>
                            <td className="text-end" style={{ width: "10%" }}>Sisa</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="fs-14 fw-semibold">
                            <td colSpan={6}>TOTAL TAGIHAN {d.vendor} : <span className="text-danger ms-1">{currencyFormat((d.data || []).reduce((a, v) => (a = a + (parseFloat(v.payable_amount || 0) - parseFloat(v.paid_amount || 0))), 0))}</span></td>
                            <td className="text-end fw-semibold" style={{ width: "10%" }}>{currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}</td>
                            <td className="text-end fw-semibold text-info" style={{ width: "10%" }}>{currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.payable_amount || 0)), 0))}</td>
                            <td className="text-end fw-semibold text-success" style={{ width: "10%" }}>{currencyFormat((d.data || []).reduce((a, v) => (a = a + parseFloat(v.paid_amount || 0)), 0))}</td>
                            <td className="text-end fw-semibold text-danger" style={{ width: "10%" }}>{currencyFormat((d.data || []).reduce((a, v) => (a = a + (parseFloat(v.amount || 0) - parseFloat(v.paid_amount || 0))), 0))}</td>
                          </tr>
                          {(d.data || []).map((data, idx) => {
                            return <tr key={idx}>
                              <td className="">{idx + 1}</td>
                              <td className="">{handleValidDate(data.transactionat)}</td>
                              <td className="">{data.transaction_no}</td>
                              <td className="">
                                <ul style={{ marginLeft: "-21px" }} className="mb-0">
                                  {(data.budget || []).map((item, key) => {
                                    return <li key={key} className="m-0 text-left">
                                      {item.label},  Rp. {currencyFormat(item.amount)}
                                    </li>
                                  }
                                  )}
                                </ul>
                              </td>
                              <td className="text-end">{currencyFormat((data.budget || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}</td>
                              <td className="text-center">{data.unit.length}</td>
                              <td className="text-end fw-semibold">{currencyFormat(data.amount)}</td>
                              <td className="text-end fw-semibold text-info">{currencyFormat(data.payable_amount || 0)}</td>
                              <td className="text-end fw-semibold text-success">{currencyFormat(data.paid_amount || 0)}</td>
                              <td className="text-end fw-semibold text-danger">{currencyFormat(data.amount - data.paid_amount || 0)}</td>
                            </tr>
                          })}
                        </tbody>
                      </table>
                    </div>
                  })}
                </CardBody>
              </Card>
            </Col>
            {/* <RecentActivity /> */}
          </Row>

          <Modal id="showModal" isOpen={modal} centered size="xl">
            <ModalHeader className="bg-light p-3" toggle={toggle}>
              {"OPNAME PEMBANGUNAN"}
            </ModalHeader>
            <ModalBody>
              <CardBody className="pt-4 ps-4 pe-4">
                <Row className="mb-4">
                  <div className="col-lg-5">
                    {(civilBudgetList || []).map((obj, i) => {
                      let arr = (obj.data || []).filter((f) => f.type === "UPAH");
                      return <div key={i} className={"mb-3"}>
                        <p className="fw-semibold fs-14 text-uppercase m-1">{obj.category}</p>
                        <div className={"pe-3 ps-3 row"}>
                          {(arr || []).map((o, idx) => {
                            let ischecked = false;
                            let checks = [];
                            for (const job of (info.jobs || [])) {
                              checks.push(job.name)
                            }
                            if (checks.includes(o.cvld_account.name))
                              ischecked = true;

                            return (
                              <div key={idx} className="hstack gap 2 mb-2">
                                <em className="avatar-xs rounded-circle" style={{ background: o.cvld_account.color, width: "20px", height: "18px", display: "block", float: "left" }}>
                                  &nbsp;
                                </em>
                                <div className="ms-2">
                                  <Label className={ischecked ? "form-check-label fw-semibold fs-12 text-uppercase" : "form-check-label fs-12 text-uppercase text-muted"}>
                                    <i className={ischecked ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line me-1"}></i> {o.cvld_account.name}
                                  </Label>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>;
                    })}
                  </div>
                  <div className="col-lg-7">
                    <h4 className="card-title mb-4 flex-grow-1">
                      History progress &nbsp;
                      {civilOpnameLoading && (
                        <>
                          <Spinner color="primary" type="grow" size={"sm"}>
                            Loading...
                          </Spinner>
                          &nbsp;
                          <Spinner color="success" type="grow" size={"sm"}>
                            Loading...
                          </Spinner>
                          &nbsp;
                        </>
                      )}
                    </h4>
                    <div className="accordionflush">
                      {(civilOpnames || []).map((item, idx) => {
                        return (
                          <div key={idx} className="accordion-item border-0">
                            <div className="accordion-header">
                              <div className="accordion-button p-2 shadow-none" id="headingOne">
                                <div className="d-flex w-100">
                                  <div className="flex-shrink-0 me-1">
                                    {item?.cvlop_createdby && item?.cvlop_createdby?.image ? (
                                      <div className="profile-user position-relative d-inline-block mx-auto">
                                        <img src={`${api.MEDIA_URL}/media/${item?.cvlop_createdby?.image}-w-200`} alt="" className="rounded-circle avatar-sm img-thumbnail user-profile-image" />
                                      </div>
                                    ) : (
                                      <div className="flex-shrink-0 avatar-sm">
                                        <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.cvlop_createdby?.name.charAt(0)}</div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="flex-grow-1 ms-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <h6 className="fs-14 mb-1">{item?.cvlop_createdby?.name}</h6>
                                      {item.cvlop_file.length > 0 && <PrintDocx data={item} />}
                                    </div>
                                    <p className="fw-normal text-muted mb-1">Memperbarui progress pembangunan dengan catatan:</p>
                                    <p className="fw-normal mb-1">{item.description || "-"}</p>
                                    <small className="text-muted">
                                      <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat).local().fromNow()}
                                    </small>

                                    <div className="row mt-3">
                                      {item.cvlop_file.map((f, i) => {
                                        return (
                                          <div key={i} className="col-lg-4">
                                            <div className="position-relative d-inline-block mx-auto">
                                              <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Row>
              </CardBody>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button type="button" className="btn btn-lg btn-light" onClick={toggle}>
                  TUTUP
                </button>
              </div>
            </div>
          </Modal>
          <Modal id="showModal" isOpen={modalMaterial} centered size="xl">
            <ModalHeader className="bg-light p-3" toggle={toggleMaterial}>
              DETAIL REALISASI ANGGARAN {label}
            </ModalHeader>
            <ModalBody>
              <CardBody>
                <div>
                  <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                    <div className="col-sm-10">
                      <Row className="m-0 p-0 ">
                        <div className="fw-semibold col-sm-5 text-start">
                          <input className="search-box  w-100 form-control" placeholder="Filter Material / Transaksi" onChange={(e) => searchList(e.target.value)} />
                        </div>
                      </Row>
                    </div>
                    <div className="col-sm-2 text-end">
                      <ExportDoc data={printDetailDoc} />
                    </div>
                  </Row>
                  <SimpleBar style={{ height: "380px" }}>
                    <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                      <thead className="align-middle">
                        <tr className="table-active">
                          <td style={{ width: "20px" }}>
                            <input
                              type="checkbox"
                              className="checkboxDetailAll me-2 form-check-input"
                              checked={expense.every((item) => item.isChecked)}
                              onChange={() => {
                                const allChecked = expense.every((item) => item.isChecked);
                                const updatedData = expense.map((item) => ({
                                  ...item,
                                  isChecked: !allChecked,
                                }));
                                setExpense(updatedData);
                              }}
                            />
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Tanggal
                          </td>
                          <td>Material</td>
                          <td className="text-center" style={{ width: "170px" }}>
                            No Transaksi
                          </td>
                          <td className="text-center" style={{ width: "170px" }}>
                            Jumlah
                          </td>
                          <td className="text-center">Keterangan</td>
                        </tr>
                      </thead>
                      <tbody id="newlink">
                        {(expense || []).map((o, i) => {
                          return (
                            <tr key={i} id={i} className="product">
                              <td className="product-id">
                                <input
                                  type="checkbox"
                                  className="checkboxDetail me-2 form-check-input"
                                  checked={o.isChecked}
                                  onChange={() => {
                                    const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                    setExpense(updatedData);
                                  }}
                                />{" "}
                                {i + 1}
                              </td>
                              <td className="text-center">{handleValidDate(o.transactionat)}</td>
                              <td className="text-start">{o.name}</td>
                              <td className="text-center">{o.transaction_no}</td>
                              <td className="text-center">{currencyFormat(parseFloat(o.amount))}</td>
                              <td className="text-center">{o.description}</td>
                            </tr>
                          );
                        })}
                        {expense.length === 0 && (
                          <tr>
                            <td colSpan="7" className="p-3 text-center">
                              Belum ada realisasi
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </SimpleBar>
                </div>
              </CardBody>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalMaterial(false);
                  }}
                >
                  TUTUP
                </button>
              </div>
            </div>
          </Modal>
          <Card id="dashboard-custom-tooltip" className="border">
            <CardBody className={info && info.weight ? "" : "d-none"}>
              <div className="d-flex align-items-center mb-3">
                <div className="avatar-md me-3 flex-shrink-0">
                  <div className="avatar-title bg-soft-info rounded">
                    <img src={logo} alt="" className="avatar-md" />
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h5 className="fs-15 fw-bold mb-1">{info && info.name}</h5>
                  <div className="mb-1">
                    Bobot Tercapai <span className="fw-semibold">{info.weight ? info.weight : 0} %</span>
                  </div>
                  <div className="mb-1" style={{ clear: "both" }}>
                    <em className="avatar-xs" style={{ background: info.color, width: "22px", height: "22px", display: "block", float: "left", marginRight: "5px" }}>
                      &nbsp;
                    </em>{" "}
                    {info.progress}
                  </div>
                </div>
              </div>
              <div className="">
                {(info.jobs || []).map((obj, i) => {
                  return <div key={i} className={"mb-1"}>
                    <p className="fw-semibold fs-14 text-uppercase m-1">{obj.category}</p>
                    <div className="hstack gap 2">
                      <div className="ms-2">
                        <Label className={obj.isFinished ? "form-check-label fw-semibold fs-10 text-uppercase" : "form-check-label fs-10 text-uppercase text-muted"}>
                          <i className={obj.isFinished ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line me-1"}></i> {obj.name}
                        </Label>
                      </div>
                    </div>
                  </div>;
                })}
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProgressDashboard;
